import * as React from "react";
import { WithNamespaces, withNamespaces } from "react-i18next";

interface Props {
  connect: (login, pwd) => void;
}
interface State {
  login: string | null;
  pwd: string | null;
}
type PropsWithNamespaces = Props & WithNamespaces;
class LoginPage extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    login: null,
    pwd: null
  };
  submit = async e => {
    e.preventDefault();
    await this.props.connect(this.state.login, this.state.pwd);
  };
  onHandleChangeLogin = e => {
    this.setState({
      login: e.target.value
    });
  };
  onHandleChangePwd = e => {
    this.setState({
      pwd: e.target.value
    });
  };
  render() {
    return (
      <div className="login">
        <div className="login-page">
          <div className="logo mb-4" />
          
          <div className="form">
            <form onSubmit={e => this.submit(e)} className="login-form">
              <input
                onChange={e => this.onHandleChangeLogin(e)}
                type="text"
                placeholder={this.props.t("login.username")}
              />
              <input
                onChange={e => this.onHandleChangePwd(e)}
                type="password"
                placeholder={this.props.t("login.password")}
              />
              <button>{this.props.t("login.button")}</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(LoginPage);



// WEBPACK FOOTER //
// ./src/components/Login.tsx